<template>
  <div class="container-fluid mt-7">
    <div class="card">
      <base-header class="pb-6" type="">
        <div class="row align-items-center py-4">
          <div class="col-lg-6 col-7">
            <h6 class="h2 d-inline-block mb-0">Technical Overview</h6>
          </div>
        </div>
        <div class="row align-items-stretch">
          <div class="col-xl-2 col-md-3 col-md-card">
            <div class="card bg-gradient-info border-0 h-75">
              <div class="card-body text-center px-1">
                <div v-if="statusText === 'Running'">
                  <i class="fas fa-circle-check text-success fa-3x mb-2"></i>
                </div>
                <div v-else-if="statusText === 'Stopped'">
                  <i class="fas fa-circle-exclamation text-danger fa-3x mb-2"></i>
                </div>
                <div v-else class="mb-3">
                  <i class="fas fa-sync fa-spin text-white fa-2x mb-2"></i>
                </div>
                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Status</h4>
                <p class="mb-0 opacity-8 text-white h6">Status of Itrade application</p>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-md-3 col-md-card">
            <div class="card bg-gradient-info border-0 h-75">
              <div class="card-body text-center px-0">
                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                  {{ buildVersion }}
                </h1>
                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Build Version</h4>
                <p class="mb-0 opacity-8 text-white h6">The application's build version</p>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-md-3 col-md-card">
            <div class="card bg-gradient-info border-0 h-75">
              <div class="card-body text-center px-0">
                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                  {{ javaVersion }}
                </h1>
                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Java Version</h4>
                <p class="mb-0 opacity-8 text-white h6 px-1">Java runtime version of the app</p>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-md-3 col-md-card">
            <div class="card bg-gradient-info border-0 h-75">
              <div class="card-body text-center px-0">
                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                  {{ timeZone }}
                </h1>
                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">TimeZone</h4>
                <p class="mb-0 opacity-8 text-white h6">System time zone </p>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-md-3 col-md-card">
            <div class="card bg-gradient-info border-0 h-75">
              <div class="card-body text-center px-0">
                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                  {{ serverPort }}
                </h1>
                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Server Port</h4>
                <p class="mb-0 opacity-8 text-white h6">Port the app runs on</p>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-md-3 col-md-card">
            <div class="card bg-gradient-info border-0 h-75">
              <div class="card-body text-center px-0">
                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                  {{ activeProfile }}
                </h1>
                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Active Profile</h4>
                <p class="mb-0 opacity-8 text-white h6">Active Spring profiles</p>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-md-3 col-md-card">
            <div class="card bg-gradient-info border-0 h-75">
              <div class="card-body text-center px-0">
                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                  {{ osName }}
                </h1>
                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">os</h4>
                <p class="mb-0 opacity-8 text-white h6 px-xl-1">The operating system running the application</p>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-md-3 col-md-card">
            <div class="card bg-gradient-info border-0 h-75">
              <div class="card-body text-center px-0">
                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0"
                  :title="applicationReadyTime">
                  {{ formattedApplicationReadyTime }}
                </h1>
                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Startup Time</h4>
                <p class="mb-0 opacity-8 text-white h6">App's startup duration</p>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-md-3 col-md-card">
            <div class="card bg-gradient-info border-0 h-75">
              <div class="card-body text-center px-0">
                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                  {{ cacheCount || 0 }}
                </h1>
                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Caches</h4>
                <p class="mb-0 opacity-8 text-white h6">Total configured caches</p>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-md-3 col-md-card">
            <div class="card bg-gradient-info border-0 h-75">
              <div class="card-body text-center px-0">
                <h1 class="text-gradient text-white font-weight-bolder card-header-font mb-0">
                  {{ beanCount || 0 }}
                </h1>
                <h4 class="mb-0 font-weight-bolder text-white text-uppercase">Beans</h4>
                <p class="mb-0 opacity-8 text-white h6">Total spring beans</p>
              </div>
            </div>
          </div>
        </div>
      </base-header>
      <div class="container-fluid mt--6">
        <div class="row">
          <div class="col-xl-4">
            <card header-classes="bg-transparent">
              <template v-slot:header>
                <h5 class="h3 mb-0">Disk Usage</h5>
              </template>
              <div>
                <canvas :id="doughnutChartID" height="350"></canvas>
              </div>
            </card>
          </div>
          <div class="col-xl-8">
            <cacheDetail></cacheDetail>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import liquibaseDetail from "./LiquibaseDetail";
import scheduledTaskDetail from "./ScheduledTaskDetail";
import cacheDetail from "./CacheDetail";
import jdbcDetail from "./JdbcDetail";
import moment from "moment-timezone";
export default {
  components: {
    liquibaseDetail,
    scheduledTaskDetail,
    cacheDetail,
    jdbcDetail
  },
  data() {
    return {
      ordersChartID: "ordersChart",
      buildVersion: "",
      applicationStatus: "",
      cacheCount: "",
      beanCount: "",
      activeProfile: "",
      serverPort: "",
      timeZone: "",
      osName: "",
      javaVersion: "",
      items: [],
      doughnutChartID: "doughnutChart",
      diskTotal: "",
      diskFree: "",
      applicationReadyTime: "",
    };
  },
  computed: {
    statusBackground() {
      let bgColor = '';
      if (this.applicationStatus == 'DOWN') {
        bgColor = 'bg-gradient-danger';
      } else if (this.applicationStatus == 'UP') {
        bgColor = 'bg-gradient-success';
      }
      return bgColor;
    },
    statusText() {
      let text = '';
      if (this.applicationStatus == 'DOWN') {
        text = 'Stopped';
      } else if (this.applicationStatus == 'UP') {
        text = 'Running';
      }
      return text;
    },
    formattedApplicationReadyTime() {
      let timeInSeconds = parseFloat(this.applicationReadyTime) || 0;
      if (timeInSeconds < 60) {
        return `${Math.floor(timeInSeconds)} s`;
      } else if (timeInSeconds < 3600) {
        return `${Math.floor(timeInSeconds / 60)} min`;
      } else {
        let hours = Math.floor(timeInSeconds / 3600);
        let minutes = Math.floor((timeInSeconds % 3600) / 60);
        return `${hours} hr ${minutes} min`;
      }
    }
  },
  methods: {
    createDoughnutChart() {
      const ctx = document.getElementById(this.doughnutChartID).getContext("2d");
      if (this.doughnutChart) {
        this.doughnutChart.destroy();
      }
      const usedSpace = (this.diskTotal - this.diskFree).toFixed(2);
      const freeSpace = this.diskFree;
      const backgroundColors = ["#fb6340", "#11cdef"];
      this.doughnutChart = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: ["Used Space", "Free Space"],
          datasets: [
            {
              data: [usedSpace, freeSpace],
              backgroundColor: backgroundColors,
              borderWidth: 1,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          cutoutPercentage: 45,
          legend: {
            display: true,
            position: "bottom",
            labels: {
              boxWidth: 20,
              fontSize: 12,
              padding: 15,
              fontColor: "#000",
            }
          },
          plugins: {
            legend: {
              display: false,
              position: "bottom",
              align: "right",
              labels: {
                boxWidth: 20,
                padding: 15,
                font: { size: 14, weight: "bold" },
              },
            },
            tooltip: { enabled: true, mode: "index", intersect: false },
          },
        },
        plugins: [
          {
            id: "centerText",
            beforeDraw: (chart) => {
              const { width, height, ctx } = chart;
              ctx.restore();
              ctx.font = "bold 1.5em sans-serif";
              ctx.textBaseline = "middle";
              ctx.textAlign = "center";
              ctx.fillStyle = "#8898aa";
              ctx.fillText(`${this.diskTotal} GB`, width / 2, height / 2 - 11);
              ctx.save();
            },
          },
          {
            id: "sectionLabels",
            afterDraw: (chart) => {
              const { ctx } = chart;
              const meta = chart.getDatasetMeta(0);
              ctx.font = "bold 14px sans-serif";
              ctx.textBaseline = "middle";
              ctx.textAlign = "center";
              meta.data.forEach((element, index) => {
                const model = element.tooltipPosition();
                const value = chart.data.datasets[0].data[index];
                ctx.fillStyle = "#ffffff";
                let yOffset = index === 0 ? -5 : 5;
                ctx.fillText(`${value}GB`, model.x, model.y + yOffset);
              });
            },
          }
        ],
      });
    },
    getVersionInfo(dataType) {
      let data = {
        type: dataType
      };
      this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
        .then(response => {
          let result = response.server.data;
          this.buildVersion = JSON.parse(result.buildVersion);
          this.javaVersion = JSON.parse(result.javaVersion);
        })
        .catch(error => {
          console.log(error);
        });
    },
    getStatusInfo(dataType) {
      let data = {
        type: dataType
      };
      this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
        .then(response => {
          this.applicationStatus = response.server.data.status;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getCacheInfo(dataType) {
      let data = {
        type: dataType
      };
      this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
        .then(response => {
          this.cacheCount = response.server.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getApplicationReadyTime(dataType) {
      let data = {
        type: dataType
      };
      this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
        .then(response => {
          this.applicationReadyTime = response.server.data[0].value;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getBeanInfo(type) {
      let data = {
        type: type,
      };
      this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
        .then(response => {
          this.beanCount = response.server.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getDiskFree(dataType) {
      let data = {
        type: dataType
      };
      this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
        .then(response => {
          const bytes = response.server.data[0].value;
          const gigabytes = bytes / (1024 ** 3);
          const formattedGB = gigabytes.toFixed(2);
          this.diskFree = formattedGB;
          this.createDoughnutChart();
        })
        .catch(error => {
          console.log(error);
        });
    },
    getDiskTotal(dataType) {
      let data = {
        type: dataType
      };
      this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
        .then(response => {
          const bytes = response.server.data[0].value;
          const gigabytes = bytes / (1024 ** 3);
          const formattedGB = gigabytes.toFixed(2);
          this.diskTotal = formattedGB;
          this.createDoughnutChart();
        })
        .catch(error => {
          console.log(error);
        });
    },
    getEnvInfo(dataType) {
      let data = {
        type: dataType
      };
      this.$store.dispatch("techDashboardStore/getTechData", data, { root: true })
        .then(response => {
          let result = response.server.data;
          this.activeProfile = JSON.parse(result.activeProfile).map(profile => profile
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
            .join(' '))[0];
          this.serverPort = JSON.parse(result.serverPort);
          this.timeZone = this.getTimeZoneAbbreviation(JSON.parse(result.timeZone));
          this.osName = JSON.parse(result.osName);
        })
        .catch(error => {
          console.log(error);
        });
    },
    getTimeZoneAbbreviation(timeZone) {
    return moment.tz(timeZone).format("z");
  }
  },
  mounted() {
    this.getVersionInfo("APPLICATION_INFO");
    this.getStatusInfo("APPLICATION_STATUS");
    this.getCacheInfo("CACHE_COUNT");
    this.getBeanInfo("INSTANCE_COUNT");
    this.getEnvInfo("ENV_DATA");
    this.getDiskFree("DISK_FREE");
    this.getDiskTotal("DISK_TOTAL");
    this.getApplicationReadyTime("APPLICATION_START_TIME");
  },
};
</script>
<style></style>
